import React, { Component } from 'react';
import Select from 'react-select';

import {
  COLOR_1,
} from '../../config';


class InputSelect extends Component {
  customStyles = {
    control: (base, {isFocused, isSelected}) => ({
      ...base,
      borderWidth: 2,
      borderStyle: 'solid',
      borderColor: isFocused || isSelected ? COLOR_1 : '#ccc',
      borderRadius: 0,
      backgroundColor: 'white',
      boxShadow: 'none',
      '&:hover': {
        borderColor: COLOR_1,
      }
    }),
    menu: (base) => ({
      ...base,
      borderRadius: 0,
    }),

    option: (base, {isSelected}) => ({
      ...base,
      backgroundColor: isSelected ? COLOR_1 : 'white',
      color: isSelected ? 'white' : 'inherit',
      '&:hover': {
        backgroundColor: COLOR_1,
        color: 'white',
      },
    }),
  }

  
  render() {
    return (
      <Select
        styles={this.customStyles}
        {...this.props}   
      />
    );
  }
}

export default InputSelect;
